import type { SavedDashboard } from "../services/dashboard-service"

function updatedAt(dashboard: SavedDashboard): number {
  const parsed = Date.parse(dashboard.updated)
  return Number.isNaN(parsed) ? Number.NEGATIVE_INFINITY : parsed
}

/** Find the most recently saved dashboard whose persisted chat binding owns this route. */
export function findDashboardBySessionId(
  dashboards: SavedDashboard[],
  sessionId: string | null | undefined
): SavedDashboard | undefined {
  const normalizedSessionId = sessionId?.trim()
  if (!normalizedSessionId) return undefined

  return dashboards.reduce<SavedDashboard | undefined>((latest, dashboard) => {
    const storedSessionId = (dashboard.spec as { dashboardSessionId?: unknown }).dashboardSessionId
    const matches =
      typeof storedSessionId === "string" && storedSessionId.trim() === normalizedSessionId
    if (!matches) return latest
    if (!latest || updatedAt(dashboard) > updatedAt(latest)) return dashboard
    return latest
  }, undefined)
}
